import React from "react";
import {useDispatch} from "react-redux";
import {css} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {FormFieldType} from "@pg-mono/form";
import {FormikForm, handleFormikPost, IFormikSubmitFn} from "@pg-mono/formik-utils";

import {toJsonValues} from "../../../form/translate/to_json_values";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {addWarningNotification} from "../../../notifications/utils/add_warning_notification";
import {postArticleComment} from "../../actions/post_article_comment";

export const articleCommentField = {
    text: FormFieldType.Textarea,
    nick_name: FormFieldType.Input
};

const initialValues = {
    nick_name: "",
    text: ""
};

export type IArticleCommentFormValues = typeof initialValues;

export const ArticleCommentForm = (props: {articleID: number; className?: string}) => {
    const dispatch = useDispatch();

    const onSubmit: IFormikSubmitFn<IArticleCommentFormValues> = (values, formikHelpers) => {
        const parsedValues = toJsonValues(articleCommentField, values);

        handleFormikPost(postArticleComment({...parsedValues, article: props.articleID}), formikHelpers, {
            onSuccess: () => {
                dispatch(addSuccessNotification("Twój komentarz został pomyślnie wysłany i oczekuje na akceptację moderatora."));
                formikHelpers.resetForm();
            },
            onNonFieldError: () => {
                dispatch(addWarningNotification("Komentarz nie może być pusty, ani nie może zawierać niedozwolonych treści."));
            }
        });
    };

    return (
        <div className={props.className} css={articleCommentForm}>
            <Text mb={4} variant="headline_6" as="div">
                Dodaj komentarz
            </Text>

            <FormikForm onSubmit={onSubmit} initialValues={initialValues}>
                <FormikForm.Input name="nick_name" css={mb(2)} placeholder="Imię i nazwisko" />
                <FormikForm.Textarea name="text" css={[mb(3)]} placeholder="Wiadomość" />

                <FormikForm.Button variant="filled_primary">Wyślij komentarz</FormikForm.Button>
            </FormikForm>
        </div>
    );
};

const articleCommentForm = css`
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(4)};
    ${p(3, 3, 4, 3)};
`;
import React from "react";
import {useDispatch} from "react-redux";
import {css} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {FormFieldType} from "@pg-mono/form";
import {FormikForm, handleFormikPost, IFormikSubmitFn} from "@pg-mono/formik-utils";

import {toJsonValues} from "../../../form/translate/to_json_values";
import {addSuccessNotification} from "../../../notifications/utils/add_success_notification";
import {addWarningNotification} from "../../../notifications/utils/add_warning_notification";
import {postArticleComment} from "../../actions/post_article_comment";

export const articleCommentField = {
    text: FormFieldType.Textarea,
    nick_name: FormFieldType.Input
};

const initialValues = {
    nick_name: "",
    text: ""
};

export type IArticleCommentFormValues = typeof initialValues;

export const ArticleCommentForm = (props: {articleID: number; className?: string}) => {
    const dispatch = useDispatch();

    const onSubmit: IFormikSubmitFn<IArticleCommentFormValues> = (values, formikHelpers) => {
        const parsedValues = toJsonValues(articleCommentField, values);

        handleFormikPost(postArticleComment({...parsedValues, article: props.articleID}), formikHelpers, {
            onSuccess: () => {
                dispatch(addSuccessNotification("Twój komentarz został pomyślnie wysłany i oczekuje na akceptację moderatora."));
                formikHelpers.resetForm();
            },
            onNonFieldError: () => {
                dispatch(addWarningNotification("Komentarz nie może być pusty, ani nie może zawierać niedozwolonych treści."));
            }
        });
    };

    return (
        <div className={props.className} css={articleCommentForm}>
            <Text mb={4} variant="headline_6" as="div">
                Dodaj komentarz
            </Text>

            <FormikForm onSubmit={onSubmit} initialValues={initialValues}>
                <FormikForm.Input name="nick_name" css={mb(2)} placeholder="Imię i nazwisko" />
                <FormikForm.Textarea name="text" css={[mb(3)]} placeholder="Wiadomość" />

                <FormikForm.Button variant="filled_primary">Wyślij komentarz</FormikForm.Button>
            </FormikForm>
        </div>
    );
};

const articleCommentForm = css`
    background-color: #fff;
    ${borderRadius(2)};
    ${elevation(4)};
    ${p(3, 3, 4, 3)};
`;
